import { useEffect, useRef, useState } from "react";
import RightModal from "../../components/Modal/RightModal";
import SavedFilterComponent from "../../components/SavedFilters/SavedFilterComponent";
import { initialConverstionRateFilterData } from "../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../utils/utils";
import ConverstionRateFilterData from "./ConverstionRateFilterData";


const ConverstionRateFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialConverstionRateFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain();
    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const saveSearchFilterData = {
    created_start_date: filterData?.created_start_date ?? "",
    created_end_date: filterData?.created_end_date ?? "",
    created_at: filterData?.created_at ?? "",
    bds: filterData?.bds ?? "",
  };


  const handleSelectFilter = (value) => {
    const dataToSet = {
      created_start_date: value?.created_start_date ?? "",
      created_end_date: value?.created_end_date ?? "",
      created_at: value?.created_at ?? "",
      bds: value?.bds ?? "",

    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);
  };

  return (
    <div>
      <SavedFilterComponent
        from="Conversion Rate Save Filter"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialConverstionRateFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Filter"
        desc={`Enter Conversion Rate Information`}
        onFilter={handleFilter}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
        from={"Converstionrate"}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
      >
        <ConverstionRateFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} from="exclusivearchieve" />
      </RightModal>
    </div>
  );
};

export default ConverstionRateFilter;
